export default __webpack_public_path__ + "static/media/icon_review_smile_active.30425c18.svg";